// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.becker-banner-carousel {
  position: relative;
  width: 100%;
  aspect-ratio: 1920/900;
  overflow: hidden;
  background: #152046;
  color: #fff;
}
.becker-banner-carousel .becker-banner-slide,
.becker-banner-carousel .becker-banner-brand,
.becker-banner-carousel .becker-banner-campaign {
  position: absolute;
  inset: 0;
  width: 100%;
  height: 100%;
}
.becker-banner-carousel .becker-banner-brand img {
  display: block;
  width: 100%;
  height: 100%;
  object-fit: cover;
  object-position: center;
}
.becker-banner-carousel .becker-banner-brand .bannerblock {
  z-index: 1;
}
.becker-banner-carousel .becker-banner-brand .bannertext {
  z-index: 2;
}
.becker-banner-carousel .becker-banner-campaign {
  overflow: hidden;
}
.becker-banner-carousel .becker-banner-image {
  position: absolute;
  width: 100%;
  height: 100%;
  object-fit: cover;
  object-position: center;
}
.becker-banner-carousel .becker-banner-overlay {
  position: absolute;
  inset: 0;
  pointer-events: none;
  background: linear-gradient(90deg, rgba(21, 32, 70, 0.65) 0%, rgba(21, 32, 70, 0.35) 30%, rgba(21, 32, 70, 0.1) 50%, rgba(21, 32, 70, 0) 70%);
}
.becker-banner-carousel .becker-banner-content {
  position: absolute;
  z-index: 2;
  top: 50%;
  left: 9%;
  width: min(620px, 80%);
  transform: translateY(-50%);
}
.becker-banner-carousel .becker-banner-content .becker-banner-tag {
  color: #e6c785;
  font-size: 15px;
  letter-spacing: 1px;
}
.becker-banner-carousel .becker-banner-content h2 {
  color: #fff;
  font-size: clamp(34px, 4.5vw, 68px);
  font-weight: 700;
  line-height: 1.3;
  margin: 20px 0;
}
.becker-banner-carousel .becker-banner-content p {
  color: #f2f2f2;
  font-size: clamp(17px, 1.7vw, 24px);
  line-height: 1.7;
  margin-bottom: 30px;
}
.becker-banner-carousel .becker-banner-button {
  display: inline-block;
  padding: 13px 28px;
  background: #e6c785;
  color: #152046;
  font-weight: 700;
  border-radius: 4px;
  transition: background 0.2s;
}
.becker-banner-carousel .becker-banner-button:hover {
  background: #fff;
  color: #152046;
}
.becker-banner-carousel .becker-banner-pending {
  color: #e6c785;
  font-size: 15px;
}
.becker-banner-carousel .becker-banner-arrow {
  position: absolute;
  z-index: 5;
  top: 50%;
  transform: translateY(-50%);
  width: 45px;
  height: 45px;
  border: 1px solid rgba(255, 255, 255, 0.4);
  border-radius: 50%;
  background: rgba(21, 32, 70, 0.4);
  color: #fff;
  font-size: 30px;
  cursor: pointer;
}
.becker-banner-carousel .becker-banner-prev {
  left: 20px;
}
.becker-banner-carousel .becker-banner-next {
  right: 20px;
}
.becker-banner-carousel .becker-banner-dots {
  position: absolute;
  z-index: 10;
  bottom: 60px;
  left: 50%;
  transform: translateX(-50%);
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 12px;
}
.becker-banner-carousel .becker-banner-dots button {
  width: 48px;
  height: 5px;
  padding: 0;
  border: none;
  border-radius: 10px;
  background: rgba(255, 255, 255, 0.4);
  cursor: pointer;
  transition: all 0.3s ease;
}
.becker-banner-carousel .becker-banner-dots button:hover {
  background: rgba(255, 255, 255, 0.8);
}
.becker-banner-carousel .becker-banner-dots button.active {
  width: 65px;
  background: #e6c785;
}
@media (max-width: 768px) {
  .becker-banner-carousel .becker-banner-dots {
    bottom: 18px;
    gap: 8px;
  }
  .becker-banner-carousel .becker-banner-dots button {
    width: 26px;
    height: 4px;
  }
  .becker-banner-carousel .becker-banner-dots button.active {
    width: 38px;
  }
}

@media (max-width: 768px) {
  .becker-banner-carousel {
    aspect-ratio: 4/3;
  }
  .becker-banner-carousel .becker-banner-overlay {
    background: rgba(8, 19, 46, 0.68);
  }
  .becker-banner-carousel .becker-banner-content {
    left: 8%;
    width: 84%;
  }
  .becker-banner-carousel .becker-banner-content h2 {
    font-size: 28px;
  }
  .becker-banner-carousel .becker-banner-content p {
    font-size: 16px;
    margin-bottom: 20px;
  }
  .becker-banner-carousel .becker-banner-dots {
    bottom: 50px;
  }
  .becker-banner-carousel .becker-banner-dots button {
    width: 22px;
  }
}`, "",{"version":3,"sources":["webpack://./src/pages/home/styles/homeBannerCarousel.scss"],"names":[],"mappings":"AACA;EACE,kBAAA;EACA,WAAA;EACA,sBAAA;EACA,gBAAA;EACA,mBAAA;EACA,WAAA;AAAF;AAEE;;;EAGE,kBAAA;EACA,QAAA;EACA,WAAA;EACA,YAAA;AAAJ;AAII;EACI,cAAA;EACA,WAAA;EACA,YAAA;EACA,iBAAA;EACA,uBAAA;AAFR;AAKI;EACI,UAAA;AAHR;AAMI;EACI,UAAA;AAJR;AAQE;EACE,gBAAA;AANJ;AASE;EACE,kBAAA;EACA,WAAA;EACA,YAAA;EACA,iBAAA;EACA,uBAAA;AAPJ;AAUE;EACE,kBAAA;EACA,QAAA;EACA,oBAAA;EAEA,6IAAA;AATJ;AAkBE;EACE,kBAAA;EACA,UAAA;EACA,QAAA;EACA,QAAA;EACA,sBAAA;EACA,2BAAA;AAhBJ;AAkBI;EACE,cAAA;EACA,eAAA;EACA,mBAAA;AAhBN;AAmBI;EACE,WAAA;EACA,mCAAA;EACA,gBAAA;EACA,gBAAA;EACA,cAAA;AAjBN;AAoBI;EACE,cAAA;EACA,mCAAA;EACA,gBAAA;EACA,mBAAA;AAlBN;AAsBE;EACE,qBAAA;EACA,kBAAA;EACA,mBAAA;EACA,cAAA;EACA,gBAAA;EACA,kBAAA;EACA,2BAAA;AApBJ;AAsBI;EACE,gBAAA;EACA,cAAA;AApBN;AAwBE;EACE,cAAA;EACA,eAAA;AAtBJ;AAyBE;EACE,kBAAA;EACA,UAAA;EACA,QAAA;EACA,2BAAA;EACA,WAAA;EACA,YAAA;EACA,0CAAA;EACA,kBAAA;EACA,iCAAA;EACA,WAAA;EACA,eAAA;EACA,eAAA;AAvBJ;AA0BE;EACE,UAAA;AAxBJ;AA2BE;EACE,WAAA;AAzBJ;AA4BE;EACA,kBAAA;EACA,WAAA;EACA,YAAA;EACA,SAAA;EACA,2BAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,SAAA;AA1BF;AA4BE;EACE,WAAA;EACA,WAAA;EACA,UAAA;EACA,YAAA;EACA,mBAAA;EACA,oCAAA;EACA,eAAA;EACA,yBAAA;AA1BJ;AA4BI;EACE,oCAAA;AA1BN;AA6BI;EACE,WAAA;EACA,mBAAA;AA3BN;AAgCA;EACE;IACE,YAAA;IACA,QAAA;EA9BF;EAgCE;IACE,WAAA;IACA,WAAA;EA9BJ;EAgCI;IACE,WAAA;EA9BN;AACF;;AAoCA;EACE;IACE,iBAAA;EAjCF;EAmCE;IACE,iCAAA;EAjCJ;EAoCE;IACE,QAAA;IACA,UAAA;EAlCJ;EAoCI;IACE,eAAA;EAlCN;EAqCI;IACE,eAAA;IACA,mBAAA;EAnCN;EAuCE;IACE,YAAA;EArCJ;EAuCI;IACE,WAAA;EArCN;AACF","sourcesContent":["\r\n.becker-banner-carousel {\r\n  position: relative;\r\n  width: 100%;\r\n  aspect-ratio: 1920 / 900;\r\n  overflow: hidden;\r\n  background: #152046;\r\n  color: #fff;\r\n\r\n  .becker-banner-slide,\r\n  .becker-banner-brand,\r\n  .becker-banner-campaign {\r\n    position: absolute;\r\n    inset: 0;\r\n    width: 100%;\r\n    height: 100%;\r\n  }\r\n\r\n  .becker-banner-brand {\r\n    img {\r\n        display: block;\r\n        width: 100%;\r\n        height: 100%;\r\n        object-fit: cover;\r\n        object-position: center;\r\n    }\r\n\r\n    .bannerblock {\r\n        z-index: 1;\r\n    }\r\n\r\n    .bannertext {\r\n        z-index: 2;\r\n    }\r\n    }\r\n\r\n  .becker-banner-campaign {\r\n    overflow: hidden;\r\n  }\r\n\r\n  .becker-banner-image {\r\n    position: absolute;\r\n    width: 100%;\r\n    height: 100%;\r\n    object-fit: cover;\r\n    object-position: center;\r\n  }\r\n\r\n  .becker-banner-overlay {\r\n    position: absolute;\r\n    inset: 0;\r\n    pointer-events: none;\r\n\r\n    background: linear-gradient(\r\n        90deg,\r\n        rgba(21, 32, 70, 0.65) 0%,\r\n        rgba(21, 32, 70, 0.35) 30%,\r\n        rgba(21, 32, 70, 0.10) 50%,\r\n        rgba(21, 32, 70, 0) 70%\r\n    );\r\n    }\r\n\r\n  .becker-banner-content {\r\n    position: absolute;\r\n    z-index: 2;\r\n    top: 50%;\r\n    left: 9%;\r\n    width: min(620px, 80%);\r\n    transform: translateY(-50%);\r\n\r\n    .becker-banner-tag {\r\n      color: #e6c785;\r\n      font-size: 15px;\r\n      letter-spacing: 1px;\r\n    }\r\n\r\n    h2 {\r\n      color: #fff;\r\n      font-size: clamp(34px, 4.5vw, 68px);\r\n      font-weight: 700;\r\n      line-height: 1.3;\r\n      margin: 20px 0;\r\n    }\r\n\r\n    p {\r\n      color: #f2f2f2;\r\n      font-size: clamp(17px, 1.7vw, 24px);\r\n      line-height: 1.7;\r\n      margin-bottom: 30px;\r\n    }\r\n  }\r\n\r\n  .becker-banner-button {\r\n    display: inline-block;\r\n    padding: 13px 28px;\r\n    background: #e6c785;\r\n    color: #152046;\r\n    font-weight: 700;\r\n    border-radius: 4px;\r\n    transition: background 0.2s;\r\n\r\n    &:hover {\r\n      background: #fff;\r\n      color: #152046;\r\n    }\r\n  }\r\n\r\n  .becker-banner-pending {\r\n    color: #e6c785;\r\n    font-size: 15px;\r\n  }\r\n\r\n  .becker-banner-arrow {\r\n    position: absolute;\r\n    z-index: 5;\r\n    top: 50%;\r\n    transform: translateY(-50%);\r\n    width: 45px;\r\n    height: 45px;\r\n    border: 1px solid rgba(255, 255, 255, 0.4);\r\n    border-radius: 50%;\r\n    background: rgba(21, 32, 70, 0.4);\r\n    color: #fff;\r\n    font-size: 30px;\r\n    cursor: pointer;\r\n  }\r\n\r\n  .becker-banner-prev {\r\n    left: 20px;\r\n  }\r\n\r\n  .becker-banner-next {\r\n    right: 20px;\r\n  }\r\n\r\n  .becker-banner-dots {\r\n  position: absolute;\r\n  z-index: 10;\r\n  bottom: 60px;\r\n  left: 50%;\r\n  transform: translateX(-50%);\r\n  display: flex;\r\n  align-items: center;\r\n  justify-content: center;\r\n  gap: 12px;\r\n\r\n  button {\r\n    width: 48px;\r\n    height: 5px;\r\n    padding: 0;\r\n    border: none;\r\n    border-radius: 10px;\r\n    background: rgba(255, 255, 255, 0.4);\r\n    cursor: pointer;\r\n    transition: all 0.3s ease;\r\n\r\n    &:hover {\r\n      background: rgba(255, 255, 255, 0.8);\r\n    }\r\n\r\n    &.active {\r\n      width: 65px;\r\n      background: #e6c785;\r\n    }\r\n  }\r\n}\r\n\r\n@media (max-width: 768px) {\r\n  .becker-banner-dots {\r\n    bottom: 18px;\r\n    gap: 8px;\r\n\r\n    button {\r\n      width: 26px;\r\n      height: 4px;\r\n\r\n      &.active {\r\n        width: 38px;\r\n      }\r\n    }\r\n  }\r\n}\r\n}\r\n\r\n@media (max-width: 768px) {\r\n  .becker-banner-carousel {\r\n    aspect-ratio: 4 / 3;\r\n\r\n    .becker-banner-overlay {\r\n      background: rgba(8, 19, 46, 0.68);\r\n    }\r\n\r\n    .becker-banner-content {\r\n      left: 8%;\r\n      width: 84%;\r\n\r\n      h2 {\r\n        font-size: 28px;\r\n      }\r\n\r\n      p {\r\n        font-size: 16px;\r\n        margin-bottom: 20px;\r\n      }\r\n    }\r\n\r\n    .becker-banner-dots {\r\n      bottom: 50px;\r\n\r\n      button {\r\n        width: 22px;\r\n      }\r\n    }\r\n  }\r\n}\r\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
